function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs541"
}, /*#__PURE__*/React.createElement("style", {
  id: "style539"
}, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Path_36",
  "data-name": "Path 36",
  transform: "translate(-147.92,-83.15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 260.81,399 c -8.6,-11.6 -30.67,-42 -52.5,-76.71 -36.43,-58 -55.68,-101.61 -55.68,-126.21 A 108.18501,108.18501 0 0 1 369,196 c 0,24.6 -19.26,68.24 -55.69,126.21 C 291.47,357 269.4,387.35 260.81,399 Z",
  id: "path543"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M 260.81,92.56 A 103.47,103.47 0 0 0 157.33,196 c 0,16.53 9.53,51.4 54.93,123.65 19.06,30.35 38.32,57.35 48.55,71.35 10.23,-14 29.48,-41 48.54,-71.34 45.4,-72.25 54.93,-107.12 54.93,-123.65 A 103.47,103.47 0 0 0 260.81,92.56 m 0,-9.41 A 112.88,112.88 0 0 1 373.69,196 c 0,62.35 -112.88,210.78 -112.88,210.78 0,0 -112.89,-148.4 -112.89,-210.78 A 112.88,112.88 0 0 1 260.81,83.15 Z",
  id: "path545"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m 92.75,146.59 v 21.87 a 3.54,3.54 0 0 0 2.43,3.39 3.53,3.53 0 0 0 4,-1.26 l 12.79,-17.42 z",
  id: "path548"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m 163.19,64.17 a 3.52,3.52 0 0 0 -3.68,-0.25 L 53.38,119.34 a 3.54,3.54 0 0 0 0.49,6.48 l 29.5,10.09 62.83,-53.73 -48.61,58.58 49.49,16.9 a 3.68,3.68 0 0 0 1.14,0.19 3.56,3.56 0 0 0 1.84,-0.52 3.5,3.5 0 0 0 1.66,-2.5 l 13,-87.25 a 3.53,3.53 0 0 0 -1.53,-3.41 z",
  id: "path550"
});

var SvgMailinvoting = function SvgMailinvoting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold",
    viewBox: "0 0 225.77 323.63",
    width: 225.77,
    height: 323.63,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailinvoting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mailinvoting.f0e58de3.svg";
export { ForwardRef as ReactComponent };